import { faxListItemColors } from '~/pages/Fax/componentStyles/FaxListItem.colors'
import { createColorKeys } from '~/utils/chakraUtils'

export const faxColors = {
  Fax: {
    FaxListItem: faxListItemColors,
  },
}

export const faxColorKeys = createColorKeys(faxColors)
